<template>
    <v-row>
        <v-col cols="12" md="7" lg="8" v-if="!isMobile" class="img-col"/>
        <v-col cols="12" md="5" lg="4">
            <v-container class="p-relative mt-7">
                <v-row>
                    <v-col cols="12">
                        <v-img :src="imgPlaceholder" max-width="120" class="mx-auto"/>
                    </v-col>
                </v-row>
                <loading-spinner v-if="loading"/>
                <v-row v-else-if="invitation">
                    <v-col cols="12" class="title-invitation">
                        {{ $t('entrance.coach_company_invitation_title') }}
                    </v-col>
                    <v-col cols="12" class="subtitle">
                        {{ $t('entrance.coach_company_invitation_subtitle', {company: invitation.company.name}) }}
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col cols="12" class="subtitle">
                        {{ $t('entrance.coach_company_invitation_error') }}
                    </v-col>
                </v-row>

                <v-row class="container-bottom">
                    <v-col cols="6" v-if="invitation">
                        <v-btn class="normal-btn" color="error" depressed large block @click="reject"
                               :loading="rejectLoading">
                            {{ $t('common.reject') }}
                        </v-btn>
                    </v-col>
                    <v-col cols="6" v-if="invitation">
                        <v-btn class="normal-btn black--text" color="primary" depressed large block @click="accept"
                               :loading="acceptLoading">
                            {{ $t('common.accept') }}
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <logout-button outlined color="black" large block/>
                    </v-col>
                </v-row>
            </v-container>
        </v-col>
    </v-row>
</template>

<script>
import LogoutButton from "@/components/common/inputs/LogoutButton";
import {db, FieldValue} from "@/utils/Firebase";
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    name: "CoachCompanyInvitation3",
    components: {LoadingSpinner, LogoutButton},
    data() {
        return {
            loading: false,
            invitation: null,
            rejectLoading: false,
            acceptLoading: false,
        }
    },
    mounted() {
        const vm = this
        vm.loadInvitation()
    },
    methods: {
        async loadInvitation() {
            const vm = this
            vm.loading = true

            let invitationRef = await db.collection('coachInvitations')
                .where('email', '==', vm.account.email)
                .where('status', '==', 'pending')
                .limit(1).get()

            let invitation = invitationRef.docs[0] || null

            vm.invitation = !invitation ? null : {
                ...invitation.data(),
                id: invitation.id,
            }

            vm.loading = false
        },
        async reject() {
            const vm = this
            vm.rejectLoading = true

            await db.collection('coachInvitations').doc(vm.invitation.id).update({
                status: 'rejected',
            })

            await db.collection('users').doc(vm.currentUser.uid).update({
                accountType: null,
                firstLogin: false,
            })

            return await vm.$router.replace({name: 'select-profile'})
        },
        async accept() {
            const vm = this
            vm.acceptLoading = true

            await db.collection('coachInvitations').doc(vm.invitation.id).update({
                status: 'accepted',
            })

            let subscription = await db.collection('subscriptions').add({
                companyId: vm.invitation.company.id,
                coachId: vm.currentUser.uid,
                paused: false,
                createdAt: FieldValue.serverTimestamp()
            })

            await db.collection('users').doc(vm.currentUser.uid).update({
                firstLogin: false,
                coachSubscription: {
                    companyDescription: vm.invitation.company.description,
                    companyName: vm.invitation.company.name,
                    companyId: vm.invitation.company.id,
                    id: subscription.id,
                    paused: false,
                }
            })

            await db.collection('users').doc(vm.invitation.company.id).update({
                activeCoaches: FieldValue.increment(1)
            })

            return await vm.$router.replace({name: 'coach.home'})
        },
    }
}
</script>

<style scoped>

.img-col {
    position: sticky;
    top: 48px;
    background-size: cover;
    background-position: center;
    height: calc(100vh - 20px);
    background-image: url('../../assets/img/welcome.png');
}

.title-invitation {
    display: inline-block;
    font-size: 30px;
    line-height: 35px;
    font-weight: bold;
    color: #078571;
}

.subtitle {
    font-size: 20px;
    color: #707070;
}

.container-bottom {
    position: sticky;
    bottom: 0;
    margin-top: 4px;
}

</style>